import AddPositioningDeviceFittingsTypeModal from './add-positioning-device-fittings-type-modal.vue'
export default AddPositioningDeviceFittingsTypeModal
